export default {
  'zh-CN': {
    meta: {
      siteName: 'Glacix',
      homeTitle: '跨境支付一站式便捷收款 - Glacix 官网',
      acquiringTitle: '全球收单',
      collectionTitle: '全球收款',
      exchangeTitle: '货币兑换',
      paymentTitle: '全球付款',
      complianceTitle: '安全合规',
      aboutTitle: '关于我们',
      customerTitle: '联系客服',
    },
    common: {
      startNow: '立即开始',
      contactUs: '联系客服',
      registerNow: '立即注册',
      login: '登录',
      register: '注册',
      helpCenter: '帮助中心',
      languageZh: '中',
      languageEn: 'EN',
      copyright: 'Glacix 2026 版权所有',
    },
    layout: {
      nav: {
        products: '产品服务',
        compliance: '安全合规',
        about: '关于我们',
        help: '帮助中心',
      },
      productMenu: [
        { title: '全球收单', desc: '更低的成本，更好的体验' },
        { title: '全球收款', desc: '让收款无国界限制' },
        { title: '货币兑换', desc: '降低跨境支付中的成本与风险' },
        { title: '全球付款', desc: '快速、低成本国际支付' },
      ],
      footer: {
        products: '产品服务',
        legal: '法律细节',
        support: '援助与支援',
        disclaimer: '免责声明政策',
        privacy: '客户隐私政策',
        fraud: '防诈骗意识',
        company: '公司介绍',
        contact: '联系我们',
        contactPhoneLabel: '联系我们',
        shenzhenAddress: '深圳地址：广东省深圳市南山区梦海大道5033卓越前海壹号A座1202',
        hongKongAddress: '香港地址：皇后大道西77-91號荷里活中心地下D號鋪',
      },
      contactHeading: {
        default: '即刻开始探索 Glacix 一站式管理终端',
        Acquiring: '即刻开始探索 Glacix 全球收单服务',
        Collection: '即刻开始探索 Glacix 全球收款服务',
        Exchange: '即刻开始探索 Glacix 智能外汇报价引擎',
        Payment: '即刻开始探索 Glacix 全球付款服务',
      },
      contactSubheading: '您也可以联系我们的顾问，为您打造专属的自定义服务。',
    },
    customer: {
      scanTip: '请扫描企业微信二维码，与客服联系',
    },
    home: {
      heroTitle: '全球支付平台<br />助您无界增长',
      heroBody: '通过不断优化的<span>智能技术</span>，接入<span>银行间报价网络</span>并优化支付基础设施，为跨境新经济参与者提供<span>安全可靠，便捷合规</span>的全球生意收款、线上贸易业务管理及提现能力，助力<span>提升业绩及运营效率</span>。',
      integrationTitle: '一站式集成的管理终端',
      integrationItems: [
        '我们把支付网络、账户管理和店铺管理等有效集成于<span>Glacix</span>，让企业随时可以进行全球收款、兑换和全球支付。我们为<span>进出口电商、国际贸易企业、线上零售、营销广告投放、自营品牌网站</span>提供一系列技术支持方案。',
        '我们同时提供<span>多账户管理、账单管理、定期付款</span>等附加服务，并帮助企业在付款时检测对方企业<span>合规、反洗钱</span>潜在风险。'
      ],
      startTitle: '开始使用 Glacix',
      startCards: [
        {
          title: '全球收单',
          desc: '为您提供一站式的独立站收单解决方案，一个<span>API</span>内集成多种国际与本地支付方式，轻松对接即可开始全球展业。',
          cta: '开始收单',
        },
        {
          title: '全球收款',
          desc: '致力于服务广大跨境卖家，无论是线上或线下款项均可于最短时间内归集至<span>Glacix 多币种钱包</span>中。',
          cta: '开始收款',
        },
        {
          title: '货币兑换',
          desc: '自研<span>货币兑换引擎</span>，直连银行间外汇交易市场，更优的价格，更快的成交，助您管理跨境支付的风险与成本。',
          cta: '开始兑换',
        },
        {
          title: '全球付款',
          desc: '支持<span>多个地区/国家的本地支付方式以及 SWIFT GPI</span>，让您的资金在转瞬之间即可到达目的地。',
          cta: '开始付款',
        },
      ],
      accountTitle: '多种方式管理账户',
      accountBody: '<span>Glacix</span> 支持多种登录方式，无论是在办公桌前亦或者在移动环境，通过<span>双重验证方式</span>安全登录不同管理环境，随时随地进行<span>国际收付，汇率锁定</span>。',
      apiTitle: '高度集成式 API',
      apiBody: '通过<span>API</span>调用与授权您的交易操作，只需与您的现有系统进行简单对接，即可快速投入生产环境。',
      apiItems: [
        {
          title: '技术支持',
          desc: '支持<span>多种开发语言</span>，并已预设各类库，只需简单调用即可轻松接入。',
        },
        {
          title: '高度可靠',
          desc: '我们的系统正常运行时间超过<span>99.9%+</span>，而且具有高度的<span>扩展性</span>和<span>冗余性</span>。',
        },
      ],
      testimonialTitle: '使用 Glacix，全球生意不缺席',
      testimonialSubtitle: '质量服务诚信<span>AAA级</span>信用企业',
      testimonials: [
        {
          quote: '“使用 Glacix 进行收款，过程容易简单”',
          tags: ['#欧洲市场', '#独立站', '#多币种解决方案'],
          author: '黎女士，深圳市蓝气泡有限公司',
        },
        {
          quote: '“多币种收款和结汇体验都很顺畅，团队响应也很快”',
          tags: ['#跨境电商', '#资金管理', '#效率提升'],
          author: '王先生，品牌出海商家',
        },
        {
          quote: '“一套后台就能管理不同地区业务，日常运营轻松很多”',
          tags: ['#全球展业', '#店铺管理', '#支付整合'],
          author: '陈女士，国际贸易企业',
        },
      ],
      creditTitle: 'AAA级互联网企业',
      creditBody: 'Glacix 被<span>中国商务诚信公共服务平台</span>评为<span>AAA级企业信用等级</span>及<span>AAA级质量服务诚信单位</span>。我们的团队为国际电商及贸易企业提供<span>全球收款及支付服务</span>，不断致力于为跨境新经济参与者提升全球竞争力而变革。',
      creditItems: [
        '严格保障客户数据与隐私<span>数据与隐私</span>',
        '<span>动态加密化</span>数据传输通道',
        '系统正常运行时间<span>99.9%+</span>',
      ],
      safeTitle: '透明合规，保护您的资金安全',
      safeBody: '依托<span>多年</span>的跨境支付行业经验，Glacix 以行业<span>最高标准</span>建立完善的交易风控系统，严格保障用户信息及资金安全。',
      safeDetail: '查看详情',
      safeItems: [
        {
          title: '反恐怖融资',
          desc: '我们甄别可疑地区的交易，并及时更新<span>FATF反洗钱金融行动特别工作组</span>的名单，确保满足被监管责任与义务。',
        },
        {
          title: '国际反洗钱',
          desc: '我们<span>严格遵循</span>国际及不同司法管辖区反恐怖融资政策，及时<span>上报可疑交易，拒绝</span>敏感及异常交易的执行。',
        },
        {
          title: '国际反贪污',
          desc: '我们与国际知名金融风险情报管理机构<span>Lexis Nexis</span>合作，甄别不同司法管辖区的被禁及限制名单，对可能发生的贪污事件进行<span>监控</span>。',
        },
      ],
    },
    about: {
      heroTitle: '全球支付平台 助您无界增长',
      heroBody: '基于生态场景，为客户创造价值，拉近中小微企业与世界的距离<br />以数字化技术服务中小微企业，灵活高效的资金成本管理体系，让全球跨境贸易收支更加灵活高效',
      introTitle: '关于我们',
      introItems: [
        '<span>Glacix</span> 成立于<span>2018</span>年，是一家运用智能科技及领先合规方案的创新型服务型科技企业，旨在通过不断<span>优化技术能力及金融流程</span>，为国际中小微企业及国际商务人士获得<span>低成本，安全，触手可及和可持续</span>的整体<span>资金管理</span>和整体<span>收付管理</span>方案。',
        '对于未来，我们有无数种构想，曾经那些看似遥不可及的可能，现在已经被互联网的力量逐步实现。我们期望通过<span>不断优化的资金管理方案和智能型技术</span>，不断<span>降低全球收付及资金管理成本</span>，为中小微企业及消费者创造更大价值，为全球商务发展带来更多便利。',
      ],
      coverTitle: '全球覆盖',
      coverBody: 'Glacix 的服务支持 50+ 国家，无缝连接的全球服务，睿智万千客户的首选。',
      regions: ['阿拉伯联合酋长国', '巴林', '中国', '中国香港', '印度', '印度尼西亚', '以色列', '日本', '科威特', '马来西亚', '阿曼', '菲律宾', '卡塔尔', '沙特', '泰国', '土耳其', '新加坡', '欧盟', '保加利亚', '克罗地亚', '捷克', '丹麦', '匈牙利', '挪威', '瑞典', '波兰', '罗马尼亚', '瑞士', '英国', '加拿大', '美国', '墨西哥', '澳大利亚', '新西兰'],
    },
    compliance: {
      heroTitle: '合规与受监管义务',
      heroBody: '通过我们领先的合规管理及行业合规经验，以<span>行业最高标准</span>建立完善的合规管理框架与交易风控体系，确保满足业务当地的<span>合规政策要求</span>，并保障<span>用户信息安全及资金安全</span>。',
      safeTitle: '透明合规，保护您的资金安全',
      safeBody: '依托<span>多年</span>的跨境支付行业经验，Glacix 以行业<span>最高标准</span>建立完善的交易风控系统，严格保障用户信息及资金安全。',
      safeItems: [
        {
          title: '反恐怖融资',
          desc: '我们甄别可疑地区的交易，并及时更新<span>FATF反洗钱金融行动特别工作组</span>的名单，确保满足被监管责任与义务。',
        },
        {
          title: '国际反洗钱',
          desc: '我们<span>严格遵循</span>国际及不同司法管辖区反恐怖融资政策，及时<span>上报可疑交易，拒绝</span>敏感及异常交易的执行。',
        },
        {
          title: '国际反贪污',
          desc: '我们与国际知名金融风险情报管理机构<span>Lexis Nexis</span>合作，甄别不同司法管辖区的被禁及限制名单，对可能发生的贪污事件进行<span>监控</span>。',
        },
      ],
      privacyTitle: '隐私保护',
      privacyItems: [
        {
          title: '用户隐私保障',
          desc: '我们致力于<span>保护客户隐私</span>，所有资料在读取、调用或营销前均会<span>征求客户的明确同意</span>。',
        },
        {
          title: '数据加密措施',
          desc: '所有银行信息及客户数据均通过<span>AES-256</span>在磁盘加密，解密密钥在单独的机器进行储存。',
        },
      ],
      licenseTitle: '服务持牌许可及义务',
      licenseBody: '我们是一家国际持牌公司，同时持有<span>美国货币及转移牌照 (Money Services License)、香港金钱服务者牌照 (Money Services Operator)、加拿大货币服务牌照 (Money Services Business)</span> 牌照许可。',
      licenses: [
        '美国货币及转移牌照 MSB',
        '香港金钱服务者牌照 MSO',
        '加拿大货币服务牌照 MSB',
      ],
    },
    services: {
      acquiring: {
        icon: '全球收单',
        heroTitle: '专为海外业务设计的收单设施，即刻接入，链接全球',
        heroBody: '我们提供灵活的<span>集成选项</span>，让您的国际客户用他们喜欢的方式付款。仅需<span>简单对接</span>，即可快速获取多种<span>国际主流信用卡</span>及<span>本地支付收单</span>能力，让您的业务在海外迅速拓展。',
        shopTitle: '潮流青春',
        shopBody: '懂生活的人，对家居<span>做减法</span>，对生活做加法，一款造型简约舒适居家的沙发，无疑是最佳选择。',
        connectionTitle: '选择适合您的对接方式',
        connectionBody: 'Glacix 提供灵活的对接选项，可根据您的情况<span>自由选择</span>。',
        connectionItems: [
          { title: 'API 接入', desc: '可高度<span>定制化</span>付款流程，无需跳转至第三方结账页面。' },
          { title: 'SDK 接入', desc: '使用 Glacix 移动<span>SDK</span>，在您的<span>iOS</span>或<span>Android</span>设备应用内收款。' },
          { title: '委托接入', desc: '适用于<span>不具备开发能力的客户</span>，可委托 Glacix 技术团队代为接入。' },
        ],
        optimizationTitle: '优化成交率增加收入',
        optimizationBody: 'Glacix 会关注<span>每一笔被拒绝的</span>交易订单，并通过强大的机器学习能力解析其拒绝原因并发起重试。',
        optimizationItems: ['智能付款重试', '对接卡组织', '动态验证卡片信息', '储存凭证优化'],
        intelligentTitle: '智能打击恶意拒付',
        intelligentBody: 'Glacix 依托<span>机器学习技术</span>检测和<span>阻止</span>潜在的<span>恶意拒付</span>风险，助您更准确地区分欺诈者与客户，并对高风险付款采取动态的<span>3DS</span>验证措施。',
        intelligentItems: ['设备指纹检测', '采用领先收单技术服务', '动态 3D 安全验证', 'IP 欺诈及代理检测'],
        processTitle: '使用流程',
        processBody: '简单几步即可开通<span>全球收单服务</span>，覆盖多个主流币种，一站式满足您的全球收款需求。',
        processItems: [
          { title: '注册', desc: '注册成为<span>Glacix</span>用户。' },
          { title: '绑定', desc: '店铺后台<span>绑定</span> Glacix 全球收款账户。' },
          { title: '收单', desc: '将店铺资金<span>提现</span>至全球收款账户。' },
        ],
      },
      collection: {
        icon: '全球收款',
        heroTitle: '一键开启全球收款服务，全球展业收款无忧',
        heroBody: '支持<span>多币种、多平台</span>的本地收款账户，无论您身在何处，都能<span>像当地人一般</span>实时收款，告别<span>漫长</span>的入账等待期。',
        openTitle: '便捷开户',
        openBody: '告别<span>繁琐、漫长</span>的银行开户流程，<span>线上无纸化</span>注册，最快当天通过审核。',
        openItems: [
          { title: '灵活注册流程', desc: '自由选择<span>账户等级</span>，轻松定义账户的功能或服务权限，实现高效管理。' },
          { title: '无障碍全球展业', desc: '为您管理复杂的国际支付和货币兑换，让您在全球范围内<span>无障碍交易</span>，展业全球。' },
        ],
        accountTitle: '多币种本地收款账户',
        accountBody: '支持<span>多币种、多平台</span>的本地收款账户，<span>实时</span>清算，告别漫长的入账等待期。',
        accountItems: [
          { title: '支持主流货币', desc: '简单快速开设多币种账户，覆盖<span>美元、欧元、英镑、日元</span>等主流币种。' },
          { title: '支持实时清算', desc: '告别漫长入账等待期，最快<span>支付当天</span>即可成功收取款项并发起提现。' },
        ],
        shopTitle: '多渠道多店铺管理',
        shopBody: '一个账号管理多渠道<span>多店铺</span>资金，操作便捷，高效省心。',
        shopItems: [
          { title: '支持多个主流平台', desc: '支持自助完成店铺绑定，统一管理各店铺收支，账目更加清晰。' },
          { title: '账户资金实时管理', desc: '自由查阅历史交易信息，便捷导出交易数据，轻松规划未来资金路径。' },
        ],
        processTitle: '使用流程',
        processBody: '简单几步即可开通<span>全球收款服务</span>，覆盖多个主流币种，一站式满足您的全球收款需求。',
        processItems: [
          { title: '注册', desc: '注册成为<span>Glacix</span>用户。' },
          { title: '绑定', desc: '店铺后台<span>绑定</span> Glacix 全球收款账户。' },
          { title: '收款', desc: '将店铺资金<span>提现</span>至全球收款账户。' },
        ],
      },
      exchange: {
        icon: '货币兑换',
        heroTitle: '智能外汇报价引擎',
        heroBody: '无论是<span>平台级企业、同业机构</span>或是<span>中小微跨境电商</span>，均能通过我们的外汇引擎直连<span>银行间外汇交易市场</span>，享受<span>远优于</span>市场水平的价格、丰富的汇率管理工具以及更快的成交速度，助您<span>降低跨境支付中的成本与风险</span>。',
        experienceTitle: '更优的兑换体验',
        experienceBody: '提供<span>24小时不间断</span>主动报价与交易执行服务，并引入<span>第三方</span>市场参考价作比对。',
        experienceItems: [
          { title: '主动报价推送', desc: '告别繁杂的询价机制，<span>实时主动推送最新报价</span>，让您离市场更近一步。' },
          { title: '第三方参考价', desc: '主动引入第三方实时市场报价以供参考，确保汇率报价<span>高度透明</span>。' },
        ],
        rateTitle: '透明汇率，所见即所得',
        rateBody: '报价有效期长达<span>30秒</span>，无等待成交期，真正实现所见即所得。',
        rateItems: [
          { title: '30秒有效期', desc: '<span>远优于行业水平</span>的报价有效期限，兼顾您的风险控制需求。' },
          { title: '无价格歧视', desc: '公平对待每一笔交易，哪怕小金额交易也能享受<span>最优报价</span>。' },
        ],
        toolTitle: '更丰富的敞口管理工具',
        toolBody: '最高可提供长达<span>30天</span>的远期可执行报价，并根据您的<span>资金计划</span>提供最优选择。',
        toolItems: [
          { title: '即期交易', desc: '支持提供<span>T+0至T+2</span>的即期报价，照顾您的近期兑换需求。' },
          { title: '远期交易', desc: '支持提供长达<span>30天</span>的远期报价，与您的资金计划进行<span>无缝对接</span>。' },
        ],
        processTitle: '使用流程',
        processBody: '简单几步即可快速接入<span>智能外汇报价引擎</span>，覆盖<span>16+</span>主流币种，助您管理<span>不同货币间</span>的成本与风险。',
        processItems: [
          { title: '注册', desc: '注册成为<span>Glacix</span>用户。' },
          { title: '交易', desc: '<span>选择</span>您所需兑换的<span>货币及日期</span>。' },
          { title: '交割', desc: '兑换后的资金将直接存入您的<span>多币种钱包</span>。' },
        ],
      },
      payment: {
        icon: '全球付款',
        heroTitle: '轻松接入全球支付网络',
        heroBody: '通过 Glacix 全球支付网络，实现<span>快速、低成本</span>国际支付，支持<span>多种本地化支付方式</span>以及领先的<span>SWIFT GPI</span>支付。',
        complianceTitle: '简化合规负担',
        complianceBody: '国际付款往往涉及持续的交涉与沟通，以满足不断变化的国际合规要求。Glacix 通过<span>提前穿透式审查</span>，让你的付款<span>时刻保持合规状态</span>。',
        engineTitle: '智能路由引擎',
        engineBody: '优化支付路径，加速款项到账，减少中间行费用，支持多达<span>16+ 币种</span>和<span>130+ 国家/地区</span>。',
        manageTitle: '便捷付款管理',
        manageBody: '<span>可视化管理</span>资金链路，确保款项来源及去向均有迹可寻，全方面赋能您的业务。',
        processTitle: '使用流程',
        processBody: '简单几步即可开通<span>全球付款服务</span>，覆盖多个主流币种，一站式满足您的全球付款需求。',
        processItems: [
          { title: '充值或收款', desc: '通过 Glacix 全球收款、全球收单或直接从您的银行账户进行<span>充值</span>。' },
          { title: '添加联系人', desc: '将您的常用供应商信息添加至<span>企业通讯录</span>，并选择支付方式。' },
          { title: '发起付款', desc: '发起<span>付款请求</span>，通过客户端即可随时追踪订单状态。' },
        ],
      },
    },
    components: {
      apiAnimation: {
        paymentMethod: '银行卡支付',
        cardNumber: '卡号',
        expiryDate: '有效期',
      },
      phoneAnimation: {
        title: '钱包管理',
        actions: ['充值', '收款', '换汇', '汇款'],
        historyTitle: '交易历史',
        viewMore: '查看更多',
        bottomTabs: ['钱包管理', '交易记录'],
        cnyHistory: ['充值', '收款 - 来自 Sandy', '汇款 - 给 SWORD', '收款 - 来自 Sandy', '汇款 - 给 SWORD', '充值'],
        usdHistory: ['汇款 - 给 Sandy', '充值', '收款 - 来自 SWORD', '汇款 - 给 Sandy', '收款 - 来自 SWORD', '充值'],
      },
      exchangeForm: {
        pay: '支付',
        bankTransfer: '银行转账',
        fee: '费用',
        serviceFee: '服务手续费',
        totalFee: '总费用',
        amountExchanged: '执行兑换金额',
        rate24h: '执行汇率（24小时）',
        receive: '收到',
      },
    },
  },
  'en-US': {
    meta: {
      siteName: 'Glacix',
      homeTitle: 'One-stop Cross-border Payments and Collections - Glacix',
      acquiringTitle: 'Global Acquiring',
      collectionTitle: 'Global Collection',
      exchangeTitle: 'FX Conversion',
      paymentTitle: 'Global Payouts',
      complianceTitle: 'Security & Compliance',
      aboutTitle: 'About Us',
      customerTitle: 'Contact Support',
    },
    common: {
      startNow: 'Get Started',
      contactUs: 'Contact Us',
      registerNow: 'Register Now',
      login: 'Log In',
      register: 'Sign Up',
      helpCenter: 'Help Center',
      languageZh: '中',
      languageEn: 'EN',
      copyright: 'Copyright 2026 Glacix',
    },
    layout: {
      nav: {
        products: 'Products',
        compliance: 'Compliance',
        about: 'About',
        help: 'Help Center',
      },
      productMenu: [
        { title: 'Global Acquiring', desc: 'Lower costs and a better payment experience' },
        { title: 'Global Collection', desc: 'Borderless collection for global growth' },
        { title: 'FX Conversion', desc: 'Reduce cost and risk in cross-border payments' },
        { title: 'Global Payouts', desc: 'Fast, low-cost international payments' },
      ],
      footer: {
        products: 'Products',
        legal: 'Legal',
        support: 'Support',
        disclaimer: 'Disclaimer Policy',
        privacy: 'Privacy Policy',
        fraud: 'Fraud Awareness',
        company: 'Company',
        contact: 'Contact Us',
        contactPhoneLabel: 'Contact Us',
        shenzhenAddress: 'Shenzhen: Suite 1202, Tower A, Excellence Qianhai One, 5033 Menghai Avenue, Nanshan District, Shenzhen',
        hongKongAddress: 'Hong Kong: Shop D, G/F, Hollywood Centre, 77-91 Queen’s Road West',
      },
      contactHeading: {
        default: 'Start exploring the Glacix all-in-one operating console',
        Acquiring: 'Start exploring Glacix global acquiring',
        Collection: 'Start exploring Glacix global collection',
        Exchange: 'Start exploring the Glacix smart FX pricing engine',
        Payment: 'Start exploring Glacix global payouts',
      },
      contactSubheading: 'You can also speak with our advisors to build a tailored service around your business.',
    },
    customer: {
      scanTip: 'Scan the WeCom QR code to connect with our support team',
    },
    home: {
      heroTitle: 'Global Payments for Borderless Business Growth',
      heroBody: 'We continuously refine our <span>smart technology</span>, connect to <span>interbank pricing networks</span>, and optimize payment infrastructure to help modern cross-border businesses operate with <span>security, compliance, and efficiency</span> across collections, trade operations, and withdrawals while <span>improving performance and operating efficiency</span>.',
      integrationTitle: 'One Integrated Operating Console',
      integrationItems: [
        'We bring payment rails, account controls, and store operations together inside <span>Glacix</span>, so businesses can collect, convert, and pay globally from one place. We support <span>import and export e-commerce, international trade, online retail, ad spend, and direct-to-consumer brand sites</span> with practical technology solutions.',
        'We also provide services such as <span>multi-account management, billing, and scheduled payments</span>, and help businesses identify potential <span>compliance and AML</span> risks before funds are sent.'
      ],
      startTitle: 'Start with Glacix',
      startCards: [
        {
          title: 'Global Acquiring',
          desc: 'Launch a complete acquiring setup for your direct website with one <span>API</span> that combines international cards and local payment methods.',
          cta: 'Start Acquiring',
        },
        {
          title: 'Global Collection',
          desc: 'Built for cross-border sellers, online and offline funds can be consolidated into your <span>Glacix multi-currency wallet</span> in less time.',
          cta: 'Start Collecting',
        },
        {
          title: 'FX Conversion',
          desc: 'Our in-house <span>FX engine</span> connects directly to interbank markets, helping you secure sharper pricing and faster execution.',
          cta: 'Start Converting',
        },
        {
          title: 'Global Payouts',
          desc: 'Support <span>local payout methods across regions and countries plus SWIFT GPI</span>, so your funds reach the destination in moments.',
          cta: 'Start Paying',
        },
      ],
      accountTitle: 'Manage Accounts Your Way',
      accountBody: '<span>Glacix</span> supports multiple sign-in methods for desktop and mobile workflows, with <span>two-factor authentication</span> to access international collections, payouts, and FX locks securely from anywhere.',
      apiTitle: 'Highly Integrated API',
      apiBody: 'Authorize and trigger transactions through our <span>API</span>. A lightweight integration with your existing system is enough to move quickly into production.',
      apiItems: [
        {
          title: 'Developer Ready',
          desc: 'Support for <span>multiple programming languages</span> with prebuilt libraries makes onboarding straightforward.',
        },
        {
          title: 'Highly Reliable',
          desc: 'Our platform maintains <span>99.9%+</span> uptime with strong <span>scalability</span> and <span>redundancy</span>.',
        },
      ],
      testimonialTitle: 'Use Glacix and Keep Business Moving Worldwide',
      testimonialSubtitle: 'An <span>AAA-rated</span> quality and service enterprise',
      testimonials: [
        {
          quote: '"Collecting with Glacix was simple from start to finish."',
          tags: ['#Europe', '#DTC', '#Multi-currency'],
          author: 'Ms. Li, Shenzhen Blue Bubble Co., Ltd.',
        },
        {
          quote: '"Multi-currency collection and conversion both feel smooth, and the team responds quickly."',
          tags: ['#Cross-border', '#Treasury', '#Efficiency'],
          author: 'Mr. Wang, Global Brand Merchant',
        },
        {
          quote: '"One console for multiple regions made daily operations much easier."',
          tags: ['#GlobalGrowth', '#StoreOps', '#Payments'],
          author: 'Ms. Chen, International Trade Company',
        },
      ],
      creditTitle: 'AAA-rated Internet Enterprise',
      creditBody: 'Glacix has been recognized by the <span>China Business Integrity Public Service Platform</span> with <span>AAA enterprise credit</span> and <span>AAA quality service integrity</span>. We provide <span>global collection and payout services</span> for international e-commerce and trading companies and continue to strengthen the global competitiveness of the new cross-border economy.',
      creditItems: [
        'Strong protection for customer data and <span>privacy</span>',
        '<span>Dynamically encrypted</span> data transmission channels',
        'System uptime of <span>99.9%+</span>',
      ],
      safeTitle: 'Transparent Compliance to Protect Your Funds',
      safeBody: 'Backed by <span>years</span> of cross-border payments experience, Glacix applies the <span>highest industry standards</span> to transaction monitoring and risk control, safeguarding customer data and funds.',
      safeDetail: 'Learn More',
      safeItems: [
        {
          title: 'Counter Terrorist Financing',
          desc: 'We identify suspicious activity in high-risk jurisdictions and keep the <span>FATF</span> lists up to date to meet regulatory duties.',
        },
        {
          title: 'Global AML',
          desc: 'We <span>strictly follow</span> anti-terrorist financing rules across jurisdictions, <span>report suspicious transactions</span>, and block sensitive or abnormal payments.',
        },
        {
          title: 'Anti-corruption',
          desc: 'Together with <span>Lexis Nexis</span>, we screen prohibited and restricted lists across jurisdictions and <span>monitor</span> potential corruption risks.',
        },
      ],
    },
    about: {
      heroTitle: 'A Global Payments Platform for Borderless Growth',
      heroBody: 'We build around real business ecosystems to create value and bring small and medium-sized businesses closer to the world.<br />Through digital capabilities and flexible capital management, we make cross-border trade flows more efficient.',
      introTitle: 'About Us',
      introItems: [
        '<span>Glacix</span> was founded in <span>2018</span> as an innovative technology services company combining smart technology with advanced compliance solutions. We keep <span>optimizing technology and financial workflows</span> to deliver <span>cost-effective, secure, accessible, and sustainable</span> solutions for <span>treasury management</span> and <span>pay-in / pay-out management</span>.',
        'We believe ideas that once felt far away are now possible through the internet. By continually improving our treasury solutions and intelligent technology, we aim to <span>reduce the cost of global funds movement and management</span> and create greater value for businesses and consumers worldwide.',
      ],
      coverTitle: 'Global Coverage',
      coverBody: 'Glacix services support more than 50 countries, connecting businesses to seamless global capabilities.',
      regions: ['United Arab Emirates', 'Bahrain', 'China', 'Hong Kong SAR', 'India', 'Indonesia', 'Israel', 'Japan', 'Kuwait', 'Malaysia', 'Oman', 'Philippines', 'Qatar', 'Saudi Arabia', 'Thailand', 'Turkey', 'Singapore', 'European Union', 'Bulgaria', 'Croatia', 'Czech Republic', 'Denmark', 'Hungary', 'Norway', 'Sweden', 'Poland', 'Romania', 'Switzerland', 'United Kingdom', 'Canada', 'United States', 'Mexico', 'Australia', 'New Zealand'],
    },
    compliance: {
      heroTitle: 'Compliance and Regulatory Responsibilities',
      heroBody: 'With strong compliance management and industry expertise, we apply the <span>highest standards</span> to our compliance framework and transaction risk controls to meet <span>local regulatory requirements</span> and protect <span>customer data and funds</span>.',
      safeTitle: 'Transparent Compliance to Protect Your Funds',
      safeBody: 'Backed by <span>years</span> of cross-border payments experience, Glacix applies the <span>highest industry standards</span> to transaction monitoring and risk control, safeguarding customer data and funds.',
      safeItems: [
        {
          title: 'Counter Terrorist Financing',
          desc: 'We identify suspicious activity in high-risk jurisdictions and keep the <span>FATF</span> lists up to date to meet regulatory duties.',
        },
        {
          title: 'Global AML',
          desc: 'We <span>strictly follow</span> anti-terrorist financing rules across jurisdictions, <span>report suspicious transactions</span>, and block sensitive or abnormal payments.',
        },
        {
          title: 'Anti-corruption',
          desc: 'Together with <span>Lexis Nexis</span>, we screen prohibited and restricted lists across jurisdictions and <span>monitor</span> potential corruption risks.',
        },
      ],
      privacyTitle: 'Privacy Protection',
      privacyItems: [
        {
          title: 'Customer Privacy',
          desc: 'We are committed to <span>protecting customer privacy</span>. We obtain <span>clear customer consent</span> before any data is accessed, used, or marketed.',
        },
        {
          title: 'Encryption Measures',
          desc: 'Banking information and customer data are encrypted at rest with <span>AES-256</span>, and decryption keys are stored on separate machines.',
        },
      ],
      licenseTitle: 'Licenses and Responsibilities',
      licenseBody: 'We are an internationally licensed company holding <span>U.S. Money Services licenses, Hong Kong Money Services Operator licenses, and Canadian Money Services Business licenses</span>.',
      licenses: [
        'United States Money Services License',
        'Hong Kong Money Services Operator License',
        'Canada Money Services Business License',
      ],
    },
    services: {
      acquiring: {
        icon: 'Global Acquiring',
        heroTitle: 'Acquiring Infrastructure Designed for Global Growth',
        heroBody: 'We provide flexible <span>integration options</span> so international customers can pay the way they prefer. With a <span>simple integration</span>, you can unlock major <span>international card schemes</span> and <span>local acquiring methods</span> to expand overseas faster.',
        shopTitle: 'Modern Living',
        shopBody: 'People who love good living subtract complexity and add comfort. A clean, comfortable sofa is always the right choice.',
        connectionTitle: 'Choose the Integration Path That Fits',
        connectionBody: 'Glacix offers flexible integration options so you can <span>choose freely</span> based on your business.',
        connectionItems: [
          { title: 'API Integration', desc: 'Build a highly <span>customized</span> checkout flow without redirecting to a third-party payment page.' },
          { title: 'SDK Integration', desc: 'Use the Glacix mobile <span>SDK</span> to accept payments inside your <span>iOS</span> or <span>Android</span> app.' },
          { title: 'Managed Integration', desc: 'Ideal for <span>teams without in-house development resources</span>; Glacix can complete the integration for you.' },
        ],
        optimizationTitle: 'Improve Approval Rates and Revenue',
        optimizationBody: 'Glacix reviews <span>every declined</span> order and uses machine learning to understand why it failed before intelligently retrying.',
        optimizationItems: ['Smart payment retries', 'Direct card-scheme connectivity', 'Dynamic card verification', 'Stored credential optimization'],
        intelligentTitle: 'Fight Malicious Chargebacks Intelligently',
        intelligentBody: 'Glacix uses <span>machine learning</span> to detect and <span>block</span> potential <span>malicious chargeback</span> risks, helping you separate fraudsters from genuine customers and apply dynamic <span>3DS</span> checks where needed.',
        intelligentItems: ['Device fingerprinting', 'Advanced acquiring technology', 'Dynamic 3D Secure checks', 'IP fraud and proxy detection'],
        processTitle: 'How It Works',
        processBody: 'Open your <span>global acquiring service</span> in just a few steps, with support for major currencies and a one-stop workflow.',
        processItems: [
          { title: 'Register', desc: 'Create your <span>Glacix</span> account.' },
          { title: 'Connect', desc: 'Connect your store backend to your Glacix global collection account.' },
          { title: 'Acquire', desc: 'Settle store funds into your global collection account.' },
        ],
      },
      collection: {
        icon: 'Global Collection',
        heroTitle: 'Turn On Global Collection in One Click',
        heroBody: 'Open <span>multi-currency, multi-platform</span> local collection accounts and receive funds <span>like a local business</span> wherever you operate, without waiting through long settlement cycles.',
        openTitle: 'Simple Account Opening',
        openBody: 'Move past <span>complex, time-consuming</span> bank onboarding with a fully <span>digital, paperless</span> application flow that can be approved as fast as the same day.',
        openItems: [
          { title: 'Flexible Onboarding', desc: 'Choose your preferred <span>account tier</span> and define product capabilities or access permissions with ease.' },
          { title: 'Operate Globally Without Friction', desc: 'We manage complex international payments and FX so you can trade <span>without barriers</span> around the world.' },
        ],
        accountTitle: 'Local Collection Accounts in Multiple Currencies',
        accountBody: 'Support <span>multi-currency, multi-platform</span> local collection accounts with <span>real-time</span> settlement and no lengthy waiting period.',
        accountItems: [
          { title: 'Major Currencies Supported', desc: 'Quickly open multi-currency accounts covering <span>USD, EUR, GBP, JPY</span>, and other leading currencies.' },
          { title: 'Real-time Settlement', desc: 'Receive funds and initiate withdrawals as early as <span>the same payment day</span>.' },
        ],
        shopTitle: 'Manage Multiple Channels and Stores',
        shopBody: 'Use one account to manage funds across channels and <span>multiple stores</span> with simpler operations and better visibility.',
        shopItems: [
          { title: 'Supports Leading Platforms', desc: 'Complete store binding yourself and manage collections and payouts across stores from one place.' },
          { title: 'Real-time Fund Management', desc: 'Review historical transactions, export data conveniently, and plan future fund flows with confidence.' },
        ],
        processTitle: 'How It Works',
        processBody: 'Enable <span>global collection</span> in just a few steps and cover major currencies through one unified setup.',
        processItems: [
          { title: 'Register', desc: 'Create your <span>Glacix</span> account.' },
          { title: 'Connect', desc: 'Bind your Glacix global collection account in your store backend.' },
          { title: 'Collect', desc: 'Withdraw store funds into your global collection account.' },
        ],
      },
      exchange: {
        icon: 'FX Conversion',
        heroTitle: 'Smart FX Pricing Engine',
        heroBody: 'Whether you are a <span>platform business, financial institution</span>, or <span>cross-border SME</span>, our FX engine connects directly to the <span>interbank FX market</span> to deliver pricing, tools, and execution speed that help <span>lower cost and risk</span>.',
        experienceTitle: 'A Better Conversion Experience',
        experienceBody: 'Benefit from <span>24/7</span> proactive pricing and trade execution, with <span>third-party</span> market references for comparison.',
        experienceItems: [
          { title: 'Proactive Price Push', desc: 'Skip manual request-for-quote workflows and receive <span>real-time rates</span> automatically.' },
          { title: 'Third-party Reference Rates', desc: 'Independent market reference rates make our pricing <span>highly transparent</span>.' },
        ],
        rateTitle: 'Transparent Rates, What You See Is What You Get',
        rateBody: 'Quotes remain valid for up to <span>30 seconds</span> with no waiting period before execution.',
        rateItems: [
          { title: '30-second Validity', desc: 'A quote validity window that is <span>well above market norms</span> while still supporting your risk controls.' },
          { title: 'No Price Discrimination', desc: 'Every trade receives fair treatment, so even smaller tickets can access <span>best-in-class pricing</span>.' },
        ],
        toolTitle: 'Richer Exposure Management Tools',
        toolBody: 'Access forward executable quotes for up to <span>30 days</span> and align them to your <span>funding plan</span>.',
        toolItems: [
          { title: 'Spot Trades', desc: 'Receive spot quotes from <span>T+0 to T+2</span> to meet near-term conversion needs.' },
          { title: 'Forward Trades', desc: 'Access forward quotes for up to <span>30 days</span> and match them to planned flows.' },
        ],
        processTitle: 'How It Works',
        processBody: 'Connect to the <span>smart FX pricing engine</span> in a few steps, across <span>16+</span> major currencies.',
        processItems: [
          { title: 'Register', desc: 'Create your <span>Glacix</span> account.' },
          { title: 'Trade', desc: '<span>Select</span> the currencies and value date you need.' },
          { title: 'Settle', desc: 'Converted funds are deposited directly into your <span>multi-currency wallet</span>.' },
        ],
      },
      payment: {
        icon: 'Global Payouts',
        heroTitle: 'Connect to a Global Payout Network with Ease',
        heroBody: 'Use the Glacix payout network for <span>fast, low-cost</span> international payments, including <span>localized payout methods</span> and industry-leading <span>SWIFT GPI</span> delivery.',
        complianceTitle: 'Reduce Compliance Burden',
        complianceBody: 'International payouts often require ongoing coordination to meet changing regulatory requirements. Glacix performs <span>look-through reviews in advance</span> so payments stay <span>continuously compliant</span>.',
        engineTitle: 'Smart Routing Engine',
        engineBody: 'Optimize payment paths, speed up settlement, and reduce intermediary fees across <span>16+ currencies</span> and <span>130+ countries / regions</span>.',
        manageTitle: 'Convenient Payout Management',
        manageBody: '<span>Visualize</span> your fund flow and keep every source and destination traceable across the lifecycle.',
        processTitle: 'How It Works',
        processBody: 'Turn on <span>global payouts</span> in just a few steps and support major currencies from one workflow.',
        processItems: [
          { title: 'Top Up or Collect', desc: 'Fund payouts through Glacix collection, acquiring, or a direct <span>bank top-up</span>.' },
          { title: 'Add Contacts', desc: 'Add your regular suppliers to the <span>business contact book</span> and choose a payout method.' },
          { title: 'Initiate Payment', desc: 'Create a <span>payment request</span> and track the order status from the client portal.' },
        ],
      },
    },
    components: {
      apiAnimation: {
        paymentMethod: 'Card Payment',
        cardNumber: 'Card Number',
        expiryDate: 'Expiry Date',
      },
      phoneAnimation: {
        title: 'Wallet',
        actions: ['Top Up', 'Collect', 'Convert', 'Send'],
        historyTitle: 'Transaction History',
        viewMore: 'View More',
        bottomTabs: ['Wallet', 'History'],
        cnyHistory: ['Top Up', 'Collected from Sandy', 'Sent to SWORD', 'Collected from Sandy', 'Sent to SWORD', 'Top Up'],
        usdHistory: ['Sent to Sandy', 'Top Up', 'Collected from SWORD', 'Sent to Sandy', 'Collected from SWORD', 'Top Up'],
      },
      exchangeForm: {
        pay: 'Pay',
        bankTransfer: 'Bank Transfer',
        fee: 'Fee',
        serviceFee: 'Service Fee',
        totalFee: 'Total Fee',
        amountExchanged: 'Exchange Amount',
        rate24h: 'Execution Rate (24h)',
        receive: 'Receive',
      },
    },
  },
}
